import { render } from "./Applications.vue?vue&type=template&id=64cd62bc&scoped=true"
import script from "./Applications.vue?vue&type=script&lang=js"
export * from "./Applications.vue?vue&type=script&lang=js"

import "./Applications.vue?vue&type=style&index=0&id=64cd62bc&scoped=true&lang=css"
import "./Applications.vue?vue&type=style&index=1&id=64cd62bc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cd62bc"]])

export default __exports__